import React from "react";
import { Grid } from "@mui/material";
import { ExpandableCard } from "./ExpandableCard";
import { RegistrationDetails } from "./RegistrationDetails";
import { StoreVisits } from "./StoreVisits";
import { PaymentRewards } from "./PaymentRewards";
import { RestaurantInfo } from "./RestaurantInfo";

interface Customer {
  registrationSource?: string;
  registrationDate?: string;
  modifiedDate?: string;
  totalVisits?: string | number | null;
  totalVisitsLifetime?: string | number | null;
  lastVisitedStoreId?: string | null;
  recentOrdersList?: any[];
  redeemablePoints?: number | null;
  savedPaymentMethodsList?: any[] | null;
  rewardOffersList?: any[];
  favoriteStoresList?: { storeId?: string; storeName?: string | null; isDefault?: boolean }[];
}

interface AccountInfoTabProps {
  customer: Customer;
}

export const AccountInfoTab = ({ customer }: AccountInfoTabProps) => (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <ExpandableCard title="Registration Details" defaultExpanded={true}>
          <RegistrationDetails customer={customer} />
        </ExpandableCard>
      </Grid>

      <Grid item xs={12} md={6}>
        <ExpandableCard title="Store Visits" defaultExpanded={true}>
          <StoreVisits customer={customer} />
        </ExpandableCard>
      </Grid>

      <Grid item xs={12} md={6}>
        <ExpandableCard title="Payment & Rewards" defaultExpanded={true}>
          <PaymentRewards customer={customer} />
        </ExpandableCard>
      </Grid>

      <Grid item xs={12} md={6}>
        <ExpandableCard title="Restaurant" defaultExpanded={true}>
          <RestaurantInfo customer={customer} />
        </ExpandableCard>
      </Grid>
    </Grid>
  );
